import TableLayout from "../../../shared/table/table-layout";
import CampaignTable from "../../../shared/campaign/all-campaign/all-campaign-table";
import CampaignMetricCards from "../../../shared/campaign/all-campaign/matric-cards";
import { useCampaigns } from "../../../../hooks/use-campaign";
import { usePaymentLinks } from "../../../../hooks/use-paymentLink";
import PaymentLinkTable from "../../../shared/paymentLinks/all-paymentLink/all-paymentLink-table";

const pageHeader = {
  title: "All Payment Link",
  breadcrumb: [],
};

export default function AllPaymentLink() {
  const { data: campaigns = [], isLoading, error } = usePaymentLinks();
 
  return (
    <div className="flex flex-col gap-20 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      <div className="flex flex-col gap-5 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      
      </div>
      <div className="@container">
        <TableLayout
          title={pageHeader.title}
          breadcrumb={pageHeader.breadcrumb}
          data={campaigns}
          fileName="all_campaigns_data"
          header="ID,Name,Username,Avatar,Email,Due Date,Amount,Status,Created At"
        >
         
          <PaymentLinkTable
            campaigns={campaigns}
            isLoading={isLoading}
            error={error}
          />
        </TableLayout>
      </div>
    </div>
  );
}
